import { render, staticRenderFns } from "./TournamentsScroller.vue?vue&type=template&id=f37da864&"
import script from "./TournamentsScroller.vue?vue&type=script&lang=js&"
export * from "./TournamentsScroller.vue?vue&type=script&lang=js&"
import style0 from "./TournamentsScroller.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports